<template>
  <div class="typhoon-red-plan">
    <section class="block">
      <h3 class="block-title">1. 核心：红色预警触发条件与定义</h3>
      <ul class="dot-list">
        <li><strong>触发信号：</strong>广州市气象台发布台风红色预警信号（或政府启动相应级别应急响应），或公司应急指挥部根据预报判定达到停业标准。</li>
        <li><strong>核心动作：</strong>立即停止营业/生产，组织人员避险，非必要人员撤离。</li>
        <li><strong>适用对象：</strong>全体员工、商户、在店顾客。</li>
      </ul>
    </section>

    <section class="block">
      <h3 class="block-title">2. 应急组织与职责（精简版）</h3>
      <table class="duty-table">
        <thead>
          <tr>
            <th>岗位/小组</th>
            <th>核心职责（红色预警期间）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>应急指挥部</td>
            <td>
              1. 发布「停业避险」正式指令。<br>
              2. 决定留守人员名单（如安保、工程）。<br>
              3. 对外联络（政府、物业）。
            </td>
          </tr>
          <tr>
            <td>各部门/门店</td>
            <td>
              1. 执行停业闭店流程（财务、设备安全）。<br>
              2. 清点并上报本部门人员位置。
            </td>
          </tr>
          <tr>
            <td>安全/工程组</td>
            <td>
              1. 负责门窗加固、设备断电、防水堵漏。<br>
              2. 巡查隐患点（招牌、高空物）。
            </td>
          </tr>
          <tr>
            <td>后勤/人事组</td>
            <td>
              1. 确认员工到家/安置点安全（钉钉/微信接龙）。<br>
              2. 安排必要的生活保障（食品、水）。
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="block">
      <h3 class="block-title">3. 应急处置流程（SOP时间轴）</h3>

      <h4 class="phase-title">阶段一：预警接收与决策（T+0 ~ 30分钟）</h4>
      <ul class="dot-list">
        <li><strong>动作：</strong>值班人员收到气象台红色预警或上级通知。</li>
        <li>
          <strong>指令：</strong>立即报告应急总指挥。总指挥确认后，通过公司大群、广播发布：「全员注意，启动台风红色预警停业避险预案。所有对外营业立即停止，各部门执行闭店程序。」
        </li>
      </ul>

      <h4 class="phase-title">阶段二：停业与避险执行（T+30分钟 ~ 2小时）</h4>
      <p class="subhead">【营业部门】闭店 SOP：</p>
      <ol class="num-list">
        <li>停止服务：停止接待新顾客，对在店顾客进行安全提示并协助疏散。</li>
        <li>资产保护：将现金、重要票据存入保险柜；将可移动贵重物品转移至高处或安全区域。</li>
        <li>设备安全：关闭非必要电源（仅保留应急照明）、关闭燃气阀门。</li>
      </ol>
      <p class="subhead">【所有人员】避险指令：</p>
      <ol class="num-list">
        <li>撤离原则：「非必要，不留人」。除经批准的极少数留守抢险人员外，其余员工必须在台风登陆前返回住所或前往安全避难点。</li>
        <li>安全确认：员工离岗前在部门群报备「已离岗」，到家后报「已安全到家」。</li>
      </ol>

      <h4 class="phase-title">阶段三：现场安全加固（T+1 ~ 3小时）</h4>
      <p class="subhead">【安全组专项动作】：</p>
      <ol class="num-list">
        <li>防风加固：检查并锁闭所有门窗，对玻璃门必要时用胶带贴「米」字。收回室外广告牌、花盆、杂物。</li>
        <li>防水防涝：在出入口堆放沙袋或挡水板；清理排水口杂物。</li>
        <li>留守人员：留守人员（如有）必须配备对讲机、应急灯、食品，并严禁在台风眼过境时外出。</li>
      </ol>

      <h4 class="phase-title">阶段四：应急结束与复工</h4>
      <ul class="dot-list">
        <li><strong>解除条件：</strong>气象台解除红色预警，且应急指挥部组织现场安全检查（无漏水、无坠落风险、电力恢复）。</li>
        <li><strong>复工指令：</strong>由应急指挥部统一发布「恢复营业通知」，严禁各部门擅自复工。</li>
      </ul>
    </section>

    <section class="block">
      <h3 class="block-title">4. 关键检查清单（Checklist）</h3>
      <ul class="check-list">
        <li>是否已发布正式停业通知（对内/对外）？</li>
        <li>所有门窗是否已锁闭加固？</li>
        <li>室外电源、燃气是否已关闭？</li>
        <li>室外可移动物品（广告牌、垃圾桶）是否已收回或固定？</li>
        <li>人员是否已清点并确认安全状态（到家/安置）？</li>
        <li>应急物资（沙袋、应急灯、对讲机）是否就位？</li>
      </ul>
    </section>

    <section class="block">
      <h3 class="block-title">5. 附件（必备）</h3>
      <ul class="dot-list">
        <li>应急联络卡：总指挥、安全负责人、物业、辖区派出所电话。</li>
        <li>疏散路线图：办公/营业场所至最近地铁站/避难点路线。</li>
        <li>物资清单：沙袋（数量）、应急手电（数量）、对讲机（频道）。</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TyphoonRedEmergencyPlan'
}
</script>

<style scoped>
.typhoon-red-plan {
  font-size: 14px;
  color: #303133;
  line-height: 1.65;
}

.block {
  margin-bottom: 28px;
}

.block:last-child {
  margin-bottom: 0;
}

.block-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-left: 4px solid #199ed7;
  padding-left: 10px;
}

.phase-title {
  margin: 18px 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
}

.phase-title:first-of-type {
  margin-top: 8px;
}

.subhead {
  margin: 10px 0 6px;
  font-weight: 600;
  color: #606266;
}

.dot-list,
.check-list,
.num-list {
  margin: 0;
  padding-left: 1.25em;
}

.dot-list li,
.check-list li {
  margin-bottom: 8px;
}

.num-list li {
  margin-bottom: 8px;
}

.duty-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.duty-table th,
.duty-table td {
  border: 1px solid #dcdfe6;
  padding: 10px 12px;
  vertical-align: top;
}

.duty-table th {
  background: #f5f7fa;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
}

.duty-table td:first-child {
  width: 120px;
  font-weight: 600;
  background: #fafafa;
  white-space: nowrap;
}

.tip-block {
  padding: 16px;
  background: #f0f9ff;
  border-radius: 6px;
  border: 1px solid #b3d8ff;
}

.tip-title {
  border-left-color: #409eff;
}

.warn-block {
  padding: 14px 16px;
  background: #fdf6ec;
  border-radius: 6px;
  border: 1px solid #faecd8;
}

.warn-text {
  margin: 0;
  font-size: 13px;
  color: #e6a23c;
  line-height: 1.6;
}
</style>
